import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not configured. Auth features will be disabled.');
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key'
);

// Type for registration records in Supabase
export interface RegistrationRecord {
  id: string;
  user_id: string;
  status: 'draft' | 'completed';
  title: string | null;
  artist: string | null;
  additional_artists: string[];
  release_date: string | null;
  duration: string | null;
  isrc: string | null;
  writers: unknown[];
  splits: unknown[];
  current_step: number;
  airtable_record_ids: string[] | null;
  registration_type?: 'form' | 'hybrid';
  created_at: string;
  updated_at: string;
}

// Check if Supabase is configured
export const isSupabaseConfigured = () => {
  return !!(supabaseUrl && supabaseAnonKey);
};
